import { memo, useEffect, useRef, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, shallowEqual } from 'react-redux'
import gsap from 'gsap'
import BtnLink from '@/components/BtnLink'
import useInView from '@/hooks/useInView'
import { isUrl, cleanOrigin } from '@/utils/path'

const ProductDownload = ({
  className,
  data,
}) => {
  const $root = useRef()
  const history = useHistory()
  const { isInView } = useInView({
    start: 'top center',
    end: 'bottom 15%',
    once: false,
    trigger: $root.current,
  })

  /*------------------------------
  Redux Connect
  ------------------------------*/
  const { strings } = useSelector((state) => ({
    strings: state.options.strings || {},
  }), shallowEqual)

  useEffect(() => {
    // Elements Animations
    gsap.to($root.current.children, {
      y: isInView ? 0 : 100,
      opacity: isInView ? 1 : 0,
      duration: 1.4,
      stagger: 0.2,
      ease: 'power4.out',
    })
  }, [isInView])

  const handleClick = useCallback((file, name) => {
    history.push(`${cleanOrigin(strings.drive_page_link)}?dir=${file}&title=${name}`)
  }, [strings.drive_page_link])

  return (
    <div
      className={className}
      ref={$root}
    >
      <h5>{data.title}</h5>
      <div dangerouslySetInnerHTML={{ __html: data.text }} />
      <div>
        {isUrl(data.file) ? (
          <BtnLink
            link={data.file}
            label={data.label}
            background
            color="light"
          />
        ) : (
          <BtnLink
            onClick={() => handleClick(data.file, data.name)}
            label={data.label}
            background
            color="light"
          />
        )}
      </div>
    </div>
  )
}

ProductDownload.defaultProps = {
  data: {},
}

export default memo(ProductDownload)
